import config from 'config'
import { initI18n } from 'locales/i18n'
import captureConsole from 'debug/console'

export default {
  configure: config.configure,
  setConfig: config.set,
  getConfig: config.get,
  requireConfig: config.require,
  captureConsole,
  initI18n,
}
